// AUPRÉA — Étape 16 : page « Mon équipe » du consultant recruteur
import { useEffect, useState } from "react";
import { C, Spinner, fmtEur } from "./shared";
import { MonEquipe } from "./Reseau";
import { MesRecrues } from "./IntegrationsAdmin";
import { getB, Stat, th, td } from "./bilansShared";

const eur = fmtEur;
const STATUT = { bilan_realise: [C.mid, "Bilan réalisé"], proposition_envoyee: [C.gold, "Proposition envoyée"], paye: [C.teal, "Payé"], sans_suite: [C.red, "Sans suite"] };
const TABS = [["recrues", "Mes recrues"], ["clients", "Clients de mon équipe"], ["reseau", "Mon réseau"]];

const ClientsEquipe = ({ d }) => (
  <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, overflowX: "auto" }} data-testid="equipe-clients">
    <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
      <thead><tr>{["Client", "Consultant de l'équipe", "Niveau", "Statut du dossier", "Montant", "Rétrocommission potentielle", "Rétrocommission acquise"].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
      <tbody>{d.items.map(x => {
        const [col, lib] = STATUT[x.statut] || [C.mid, x.statut];
        return (
          <tr key={x.id} data-testid={`equipe-client-${x.id}`}>
            <td style={{ ...td, color: C.navy, fontWeight: 600 }} data-testid={`equipe-client-nom-${x.id}`}>{x.client}</td>
            <td style={td}>{x.consultant}</td>
            <td style={td} data-testid={`equipe-client-niveau-${x.id}`}>N{x.niveau} · {Math.round(x.taux * 100)} %</td>
            <td style={{ ...td, color: col, fontWeight: 600 }}>{lib}</td>
            <td style={td}>{x.montant ? eur(x.montant) : "—"}<div style={{ fontSize: 10.5, color: C.muted }}>{x.montant ? (x.montant_type === "encaisse" ? "encaissé" : "proposition") : ""}</div></td>
            <td style={{ ...td, color: C.gold, fontWeight: 700 }} data-testid={`equipe-client-pot-${x.id}`}>{x.retro_potentielle ? <>{eur(x.retro_potentielle)}<div style={{ fontSize: 10.5, fontWeight: 400 }}>si le client règle</div></> : "—"}</td>
            <td style={{ ...td, color: C.teal, fontWeight: 700 }} data-testid={`equipe-client-acq-${x.id}`}>{x.retro_statut ? <>{eur(x.retro_acquise)}<div style={{ fontSize: 10.5, fontWeight: 400, color: x.retro_statut === "validee" ? C.teal : C.amber }}>{x.retro_statut === "validee" ? "validée" : "estimée"}</div></> : "—"}</td>
          </tr>);
      })}</tbody>
    </table>
    {d.items.length === 0 && <div style={{ padding: 30, textAlign: "center", color: C.muted }}>Aucun client dans votre équipe pour l'instant</div>}
  </div>
);

export const MonEquipeRecruteur = () => {
  const [tab, setTab] = useState("recrues");
  const [d, setD] = useState(null);
  useEffect(() => { getB("/mon-equipe/clients").then(setD); }, []);
  if (!d) return <Spinner />;
  const t = d.totaux;
  const mois = new Date(`${d.mois}-01`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return (
    <div data-testid="mon-equipe-recruteur">
      <div style={{ fontSize: 12, color: C.mid, marginBottom: 8 }}>Totaux de {mois}{d.is_partenaire_recruteur ? " · Partenaire recruteur : niveau 1 uniquement" : ""}</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 12, marginBottom: 16 }}>
        <Stat label="Rétrocommissions potentielles" value={eur(t.retro_potentielles)} sub="propositions en cours · si les clients règlent" color={C.gold} testid="equipe-tot-potentielles" />
        <Stat label="Rétrocommissions acquises" value={eur(t.retro_acquises_mois)} sub="sur les montants encaissés ce mois" color={C.teal} testid="equipe-tot-acquises" />
        <Stat label="Consultants actifs" value={t.consultants_actifs} color={C.navy} testid="equipe-tot-actifs" />
        <Stat label="Recrues en intégration" value={t.recrues_integration} color={C.purp} testid="equipe-tot-integration" />
      </div>
      <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap" }}>
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`equipe-tab-${k}`}
            style={{ padding: "8px 16px", borderRadius: 999, border: `1px solid ${tab === k ? C.navy : C.border}`, background: tab === k ? C.navy : "#fff", color: tab === k ? "#fff" : C.mid, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{l}</button>
        ))}
      </div>
      {tab === "recrues" && <MesRecrues />}
      {tab === "clients" && <ClientsEquipe d={d} />}
      {tab === "reseau" && <MonEquipe />}
    </div>
  );
};
